/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_Solo_OneInputs */

const en_platform_team_solo_one = /** @type {(inputs: Platform_Team_Solo_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your page and your calendar`)
};

const pl_platform_team_solo_one = /** @type {(inputs: Platform_Team_Solo_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoja strona i Twój kalendarz`)
};

/**
* | output |
* | --- |
* | "Your page and your calendar" |
*
* @param {Platform_Team_Solo_OneInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_solo_one = /** @type {((inputs?: Platform_Team_Solo_OneInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_Solo_OneInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_solo_one(inputs)
	return en_platform_team_solo_one(inputs)
});